import { Cell } from 'components/ReusableComponents/Table'

import styles from './NormalCell.module.scss'

const NormalCell = ({ children, ...props }) => (
  <Cell className={styles.cell} {...props}>
    <span>{children}</span>
  </Cell>
)

export default NormalCell
